/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  url?: string;
  isAuthenticated: boolean;
  hasProfile: boolean;
  fullName: string;
  cashierId: string;
  loading: boolean;
  error?: boolean;
  posProfile?: string;
}

const initialState: AuthState = {
  url: '',
  isAuthenticated: false,
  hasProfile: false,
  posProfile: '',
  loading: false,
  fullName: '',
  cashierId: '',
  error: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state: AuthState) => {
      state.loading = true;
    },
    loginSuccess: (state: AuthState, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.fullName = payload;
      state.isAuthenticated = true;
    },
    loginError: (state: AuthState) => {
      state.loading = false;
      state.error = true;
      state.isAuthenticated = false;
    },
    logOut: (state: AuthState) => {
      state.isAuthenticated = false;
      state.hasProfile = false;
      state.posProfile = '';
      state.fullName = '';
    },
    setUrl: (state: AuthState, { payload }: PayloadAction<any>) => {
      state.url = payload;
    },
    setPOSProfile: (state: AuthState, { payload }: PayloadAction<any>) => {
      state.posProfile = payload;
      state.hasProfile = true;
    },
    setCashier: (
      state: AuthState,
      { payload }: PayloadAction<Pick<AuthState, 'cashierId'>>,
    ) => {
      state.cashierId = payload.cashierId;
    },
  },
});

export const {
  setUrl,
  setPOSProfile,
  setCashier,
  login,
  loginSuccess,
  logOut,
  loginError,
} = authSlice.actions;

export default authSlice.reducer;
